var map = {
	"./_default.json": 408,
	"./ancot.json": 409,
	"./bmarken.json": 410,
	"./cittaviva.json": 411,
	"./class.json": 412,
	"./coop.json": 413,
	"./crai.json": 414,
	"./csp.json": 415,
	"./doreca.json": 416,
	"./doro.json": 417,
	"./ekom.json": 418,
	"./enel.json": 419,
	"./fashionzclub.json": 420,
	"./gdsp.json": 421,
	"./goovi.json": 422,
	"./lcng.json": 423,
	"./lie.json": 424,
	"./mauto.json": 425,
	"./mysarca.json": 426,
	"./retail.json": 427,
	"./retex-bistrot.json": 428,
	"./retex.json": 429,
	"./self-service.json": 430,
	"./smarttouch.json": 431,
	"./smkt.json": 432,
	"./voghera.json": 433,
	"./wikimuseo.json": 434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783;